import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { Skeleton } from '@progress/kendo-react-indicators';

const EnergySearchSkeletonGrid = () => {
  const rows = Array.from({ length: 6 }).map((_, index) => ({ id: index }));
  const columnHeaders = ["#", "Company", "Deal Status", "Deal Name", "Deal Team"];
  const columnWidths = [60, 100, 100, 100, 100]; 
  const renderSkeletonCell = (animationType = "pulse") => () => (
    <td className="skeleton-cell">
      <Skeleton
        shape="text"
        className="skeleton-text-cell"
        animation={{ type: animationType }}
      />
    </td>
  );

  return (
    <div className="energy-search-skeleton-container">
    <div className="skeleton-header">
      <Skeleton
        shape="text"
        className="skeleton-title"
        animation={{ type: "wave" }}
      />
      <Skeleton
        shape="text"
        className="skeleton-subtitle"
        animation={{ type: "wave" }}
      />
    </div>

    <Grid data={rows}>
      {columnHeaders.map((header, i) => (
        <Column
          key={`col-${i}`}
          title={header}
          width={`${columnWidths[i]}px`}
          cell={renderSkeletonCell(i === 0 ? "wave" : "pulse")}
        />
      ))}
    </Grid>
  </div>
  );
};

export default EnergySearchSkeletonGrid;